import { ReactNode } from 'react'

import { FormProvider, useForm } from 'react-hook-form'

import { IMultipleAutocompleteOption } from 'components/common/controller-wrapper'
import { SupplierActivationPeriod } from 'components/reports/Metrics/constants'
import { VehicleTypeFilter } from 'generated/graphql'

export interface NegotiationOverviewFilterValues {
  period: SupplierActivationPeriod
  customStart: Date | null
  customEnd: Date | null
  selectedServiceCodes: IMultipleAutocompleteOption[]
  vehicleType: VehicleTypeFilter
}

export const NEGOTIATION_OVERVIEW_DEFAULT_FILTERS: NegotiationOverviewFilterValues = {
  period: 'last90',
  customStart: null,
  customEnd: null,
  selectedServiceCodes: [],
  vehicleType: VehicleTypeFilter.All,
}

interface IProps {
  children: ReactNode
}

export const NegotiationOverviewFilterCriteria = ({ children }: IProps) => {
  const methods = useForm<NegotiationOverviewFilterValues>({
    defaultValues: NEGOTIATION_OVERVIEW_DEFAULT_FILTERS,
  })

  return <FormProvider {...methods}>{children}</FormProvider>
}
